import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const GradientLineChart = () => {
    const data = {
        labels: [
            'January-2024', 'February-2024', 'March-2024', 'April-2024',
            'May-2024', 'June-2024', 'July-2024', 'August-2024',
            'September-2024', 'October-2024', 'November-2024', 'December-2024'
        ],
        datasets: [
            {
                label: 'Last Month',
                data: [30, 35, 28, 40, 25, 30, 28, 35, 30, 38, 36, 40],
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.4, // smooth line
                fill: true,   // area fill
                pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                pointBorderWidth: 2,
                pointRadius: 4,
            },
            {
                label: 'This Month',
                data: [40, 42, 38, 44, 36, 40, 45, 42, 48, 50, 52, 55],
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.4,
                fill: true,
                pointBackgroundColor: 'rgba(75, 192, 192, 1)',
                pointBorderWidth: 2,
                pointRadius: 4,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                },
            },
            title: {
                display: true,
                text: 'Customer Satisfaction',
                align: 'start',
                font: {
                    size: 18,
                    weight: 'bold',
                }, padding: {
                    bottom: 20,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <div className='dashboard-line-chart'>
            <Line data={data} options={options} />
        </div>
    );
};

export default GradientLineChart;


